import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import "./Availability.scss";
import { BackIcon } from "../../components/Icons";
import { Button } from "react-bootstrap";
import WeeklyCalendar from "./WeeklyCalendar";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  changeJobStartTime,
  fetchProviderAvailability,
} from "../../services/auth.service";
import { selectUser } from "../../slice/authSlice";
import { toast_error, toast_success } from "../../config/Constant";
import { toast } from "react-toastify";

const Availabilty = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const location = useLocation();
  const [providerSlots, setProvideSlots] = useState({});
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedDay, setSelectedDay] = useState(new Date()); // Set default to today
  const navigate = useNavigate();

  const providerAvailability = async (date) => {
    const selectedDate = moment(date)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss");

    let payload = {
      date: selectedDate,
      providerId: user?.id,
      timezoneOffset: -180,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderAvailability(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProvideSlots(response?.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    const today = moment().startOf("day").toISOString();
    providerAvailability(today);
  }, [user?.id]);

  function addTimeAndFormatISO(date, time) {
    const momentDate = moment(date);
    const year = momentDate.year();
    const month = momentDate.month();
    const day = momentDate.date();

    const combinedDateTime = moment.tz(
      `${year}-${month + 1}-${day} ${time}`,
      "YYYY-MM-DD HH:mm",
      "Atlantic/Bermuda"
    );

    return combinedDateTime.format();
  }


  const handleSubmit = async () => {
    let payload = {
      jobId: location?.state,
      startTime: addTimeAndFormatISO(selectedDay, selectedTime),
    };
    try {
      await dispatch(setLoader(true));
      const response = await changeJobStartTime(payload);
      await dispatch(setLoader(false));
      if (response?.data?.status) {
        toast.success(response?.data?.message, toast_success);
        navigate("/provider/jobs");
      } else {
        toast.error(response?.data?.message, toast_error);
        navigate("/provider/jobs");
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
      navigate("/provider/jobs");
    }
  };

  return (
    <>
      <Header />
      <PageHeading title="Booking Calendar" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="availabilty-wrapper">
            <div className="back-wrapper" onClick={() => navigate(-1)}>
              <div className="back-icon">
                <BackIcon />
              </div>
              <div className="back-title">Booking Calendar</div>
            </div>

            <div className="box-wrapper time-slot-wrapper">
              <WeeklyCalendar
                setSelectedDay={setSelectedDay}
                selectTime={(e) => setSelectedTime(e)}
                selectedTime={selectedTime}
                fetchSlots={(e) => providerAvailability(e)}
                slots={providerSlots}
              />
            </div>
            <div>
              <Button variant="primary" disabled={!selectedTime || !selectedDay} onClick={() => handleSubmit()}>
                Change Time
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Availabilty;
